// ================================================================================================
// Entry point for Theme scripts. This is where we load all scripts required by the theme and
// initialise common elements like headers, footers, animation controllers etc
// ================================================================================================

import '../scss/_foundation.scss';

import { footerController } from '../controllers/footer.controller';
import { headerController } from '../controllers/header.controller';
import { modeController } from '../controllers/mode.controller';
import { setupTransitions } from '../setup/transitions.setup';
import { blockLifecycleController } from '../controllers/block-lifecycle.controller';
import { scrollController } from '../controllers/scroll.controller';
import { breakpointWidgetController } from '../controllers/breakpoint-widget.controller';

import '../scss/common.scss';
import '../scss/blocks.scss';
import '../scss/ros.scss';
import '../scss/image-placeholders.scss';
import '../scss/themes/mahana/theme.scss';
import '../components/HhdsIntersectionObserver/HhdsIntersectionObserver';

import { modalController } from '../controllers/modal.controller';
import { breakpointWatcher } from '../utils/breakpoint-watcher.util';
import { resizeHandler } from '../controllers/resize.controller';
import '../components/Spinner/Spinner';

// ================================================================================================
// Blocks
// ================================================================================================

blockLifecycleController.init();
breakpointWatcher.subscribe('theme', () => {
	resizeHandler.requestRebuild('breakpoint change');
});

// ================================================================================================
// Header and Footer
// ================================================================================================

modeController.init();
scrollController.init();
footerController.init();
headerController.init();
modalController.init();

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('breakpoint-widget')) breakpointWidgetController.init();

// ================================================================================================
// Barba Page Transitions
// ================================================================================================

setupTransitions();
